import { IconContainer } from './icon-button-styles'

type IconButtonProps = {
  disable?: boolean
  onClick: () => void
  labelText?: string
  icon: () => JSX.Element
}

const IconButton = ({ onClick, labelText, icon }: IconButtonProps) => (
  <IconContainer onClick={onClick} aria-label={labelText}>
    {icon()}
  </IconContainer>
)

export default IconButton
